import { render } from "./CodeProtectedComponent.vue?vue&type=template&id=5bb809a8&scoped=true"
import script from "./CodeProtectedComponent.vue?vue&type=script&lang=js"
export * from "./CodeProtectedComponent.vue?vue&type=script&lang=js"

import "./CodeProtectedComponent.vue?vue&type=style&index=0&id=5bb809a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb809a8"]])

export default __exports__